import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from './api';

// LOT 46 v2 · 1.6 · le bouton Google n'apparaît que si les clés Google de 360 sont posées sur le serveur
let demande = null;
export const useGoogle360 = () => {
  const [dispo, setDispo] = useState(false);
  useEffect(() => {
    demande = demande || axios.get(`${getApiUrl()}/auth/google-disponible`).then((r) => !!r.data?.disponible).catch(() => false);
    let vivant = true;
    demande.then((v) => { if (vivant) setDispo(v); });
    return () => { vivant = false; };
  }, []);
  return dispo;
};
